import { isUndefined } from 'lodash/fp'
import { RecursiveActionMap, createActions } from 'redux-actions'

import {
  assignedElementSelectors,
  assignedLearnpathAllSelectors,
  assignedLearnpathSelectors,
} from '../selectors'
import buildApiUrl from '../utils/buildApiUrl'

type AssignedGetPayload = {
  categoryId?: string
  isCourse?: boolean
  learnpathId?: string
}

const actions = createActions({
  LEARNPATHS: {
    ASSIGNED: {
      GET: ({
        learnpathId,
        isCourse,
        categoryId,
      }: AssignedGetPayload = {}) => ({
        options: { returnRejectedPromiseOnError: false },
        request: {
          url: buildApiUrl.assigned({
            categoryId,
            isCourse,
            learnpathId,
          }),
        },
        ...(isUndefined(learnpathId) ? {} : { learnpathId }),
        ...(isUndefined(categoryId) ? {} : { categoryId }),
        ...(isUndefined(isCourse) ? {} : { isCourse }),
      }),
      ELEMENT: {
        GET: ({ learnpathId, elementId }) => ({
          request: {
            url: buildApiUrl.assignedElement(learnpathId, elementId),
          },
        }),
      },
      CONFIRM_COMPLETION: {
        POST: ({ learnpathId }) => ({
          request: {
            url: buildApiUrl.assignedConfirmCompletion(learnpathId),
            method: 'POST',
            learnpathId,
          },
        }),
      },
    },
  },
}) as RecursiveActionMap

actions.learnpaths.assigned.getIfRequired =
  ({ learnpathId, isCourse, categoryId }: AssignedGetPayload = {}) =>
  (dispatch, getState) => {
    if (learnpathId) {
      if (
        assignedLearnpathSelectors.requiresFetch(getState(), { learnpathId })
      ) {
        return dispatch(
          actions.learnpaths.assigned.get({
            learnpathId,
            isCourse,
            categoryId,
          }),
        )
      }
    } else if (
      assignedLearnpathAllSelectors.requiresFetch(getState(), {
        isCourse,
        categoryId,
      })
    ) {
      return dispatch(actions.learnpaths.assigned.get({ isCourse, categoryId }))
    }

    return Promise.resolve()
  }

actions.learnpaths.assigned.element.getIfRequired =
  ({ learnpathId, elementId }) =>
  (dispatch, getState) => {
    const propArgs = { learnpathId, elementId }
    if (assignedElementSelectors.requiresFetch(getState(), propArgs)) {
      return dispatch(actions.learnpaths.assigned.element.get(propArgs))
    }

    return Promise.resolve()
  }

export default actions.learnpaths
